import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";

import VConsole from "vconsole";

import plugins from "./plugins/index"; // plugins
import router from "./router";
import "./permission";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";

import svgIcon from "./components/svgIcon.vue";
import "./assets/iconfont.js";
import "./assets/iconfont.css";
import "./icon/iconfont.css";
import "./styles/common.scss"
import zhCn from "element-plus/dist/locale/zh-cn.mjs";
import dir from "./directive/index";
const app = createApp(App);
import store from "./store";
import "default-passive-events";

function isUseVconsole() {
  const userAgentInfo = window.navigator.userAgent;
  const mobileAgents = [
    "Android",
    "iPhone",
    "SymbianOS",
    "Windows Phone",
    "iPad",
    "iPod",
  ];
  const mobileFlag = mobileAgents.some((mobileAgent) => {
    return userAgentInfo.indexOf(mobileAgent) > 0;
  });
  const isDev = process.env.NODE_ENV == "development";

  return mobileFlag && isDev;
}

// let vc = isUseVconsole() ? new VConsole() : "";

app.use(store);
app.use(router);
app.component("svgIcon", svgIcon);
// if(vc){
//   app.use(vc);
// }
app.use(plugins);
app.use(ElementPlus, { locale: zhCn });
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}
app.directive("has", dir.hasButton);
app.directive("loadMore", dir.selectMore);
app.mount("#app");
